"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DEFAULT_VALUES = {
    application_fee: 0.0,
    program_fees: 0.0,
    tuition_cost: 0.0,
    discounts: 0.0,
    transfered_hours: 0.0,
    kit: 0.0,
    opt_out_total: 0.0,
    strf: 0.0,
    total_charges: 0.0,
    total_program: 0.0,
    total_enrollment: 0.0,
    percentageRate: 0,
    financeCharge: 0.0,
    creditsSteps: 0.0,
    totalPayments: 0.0,
    downPayments: 0.0,
    amount_of_deposit: 0.0,
    terms_start: "",
    clock_hours: "",
    enrolled_clock_hours: "",
    hourly_rate: 0,
    allowable_absent_hours: 0
};
exports.DEFAULT_VALUES = DEFAULT_VALUES;
var DEFAULT_VALUES_INFO = {
    first_name: "",
    legal_middlename: "",
    last_name: "",
    home_phone: "",
    cell_phone: "",
    address: "",
    city: "",
    state: "",
    email: "",
    zip: ""
};
exports.DEFAULT_VALUES_INFO = DEFAULT_VALUES_INFO;
var CAMPUS_PROGRAMS_DEFAULT = [
    {
        id: 1,
        name: "Chula Vista",
        code: "Chula Vista",
        address: "CA 970 Broadway, Suite 110",
        state: "Chula Vista, CA 91911",
        phone: "619-474-6607",
        school_code: "3700511",
        addittional: {
            state: "California",
            region: "San Diego"
        },
        programs: [
            {
                id: 1,
                name: "Barbering",
                code: "Barbering"
            },
            {
                id: 2,
                name: "Barbering/Cosmetology",
                code: "Barbering/Cosmetology"
            },
            {
                id: 3,
                name: "Barbering/Cosmetology 102",
                code: "Barbering/Cosmetology 102"
            },
            {
                id: 4,
                name: "Cosmetology",
                code: "Cosmetology"
            },
            {
                id: 5,
                name: "Cosmetology 102",
                code: "Cosmetology 102"
            },
            {
                id: 8,
                name: "Esthetics / Esthetician",
                code: "Esthetics / Esthetician"
            },
            {
                id: 9,
                name: "Esthetics 102 / Esthetician 102",
                code: "Esthetics 102 / Esthetician 102"
            },
            {
                id: 10,
                name: "Esthetics 103 / Esthetician 103",
                code: "Esthetics 103 / Esthetician 103"
            },
            {
                id: 11,
                name: "Spa Nail Technician",
                code: "Spa Nail Technician"
            },
            {
                id: 12,
                name: "Makeup Artistry",
                code: "Makeup Artistry"
            }
        ]
    },
    {
        id: 2,
        name: "Poway",
        code: "Poway",
        address: "CA 13266 Poway Rd",
        state: "Poway, CA 92064",
        phone: "858-748-1490",
        school_code: "3707561",
        addittional: {
            state: "California",
            region: "San Diego"
        },
        programs: [
            {
                id: 1,
                name: "Barbering",
                code: "Barbering"
            },
            {
                id: 2,
                name: "Barbering/Cosmetology",
                code: "Barbering/Cosmetology"
            },
            {
                id: 3,
                name: "Barbering/Cosmetology 102",
                code: "Barbering/Cosmetology 102"
            },
            {
                id: 4,
                name: "Cosmetology",
                code: "Cosmetology"
            },
            {
                id: 5,
                name: "Cosmetology 102",
                code: "Cosmetology 102"
            },
            {
                id: 8,
                name: "Esthetics / Esthetician",
                code: "Esthetics / Esthetician"
            },
            {
                id: 9,
                name: "Esthetics 102 / Esthetician 102",
                code: "Esthetics 102 / Esthetician 102"
            },
            {
                id: 10,
                name: "Esthetics 103 / Esthetician 103",
                code: "Esthetics 103 / Esthetician 103"
            },
            {
                id: 11,
                name: "Spa Nail Technician",
                code: "Spa Nail Technician"
            },
            {
                id: 12,
                name: "Makeup Artistry",
                code: "Makeup Artistry"
            }
        ]
    },
    {
        id: 3,
        name: "El Cajon",
        code: "El Cajon",
        address: "CA 1073 E. Main St",
        state: "El Cajon, CA 92021",
        phone: "619-442-3407",
        school_code: "3700531",
        addittional: {
            state: "California",
            region: "San Diego"
        },
        programs: [
            {
                id: 2,
                name: "Barbering/Cosmetology",
                code: "Barbering/Cosmetology"
            },
            {
                id: 3,
                name: "Barbering/Cosmetology 102",
                code: "Barbering/Cosmetology 102"
            },
            {
                id: 4,
                name: "Cosmetology",
                code: "Cosmetology"
            },
            {
                id: 5,
                name: "Cosmetology 102",
                code: "Cosmetology 102"
            },
            {
                id: 8,
                name: "Esthetics / Esthetician",
                code: "Esthetics / Esthetician"
            },
            {
                id: 9,
                name: "Esthetics 102 / Esthetician 102",
                code: "Esthetics 102 / Esthetician 102"
            },
            {
                id: 10,
                name: "Esthetics 103 / Esthetician 103",
                code: "Esthetics 103 / Esthetician 103"
            },
            {
                id: 12,
                name: "Makeup Artistry",
                code: "Makeup Artistry"
            }
        ]
    },
    {
        id: 4,
        name: "Manhattan",
        code: "Manhattan",
        address: "KS 1130 Westloop Pl",
        state: "Manhattan, KS 66502",
        phone: "785-539-1837",
        school_code: "",
        addittional: {
            state: "Kansas",
            region: "Manhattan"
        },
        programs: [
            {
                id: 4,
                name: "Cosmetology",
                code: "Cosmetology"
            },
            {
                id: 5,
                name: "Cosmetology 102",
                code: "Cosmetology 102"
            },
            {
                id: 8,
                name: "Esthetics / Esthetician",
                code: "Esthetics / Esthetician"
            },
            {
                id: 9,
                name: "Esthetics 102 / Esthetician 102",
                code: "Esthetics 102 / Esthetician 102"
            },
            {
                id: 11,
                name: "Spa Nail Technician",
                code: "Spa Nail Technician"
            },
            {
                id: 12,
                name: "Makeup Artistry",
                code: "Makeup Artistry"
            },
            {
                id: 13,
                name: "Massage Therapy",
                code: "Massage Therapy"
            }
        ]
    }
];
exports.CAMPUS_PROGRAMS_DEFAULT = CAMPUS_PROGRAMS_DEFAULT;
//# sourceMappingURL=data:application/json;base64,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